export default __webpack_public_path__ + "static/media/photo6.9e7dff74.jpg";